import React, { Component, RefObject } from "react";

import cx from "classnames";

interface Props {
  id?: string;
  name: string;
  label?: string;
  className: string;
  ariaLabel: string;
  onBlur: (value: string | number) => any;
  onFocus: (value: string | number) => any;
  onChange: (value: string | number) => any;
  pattern?: string;
  placeholder?: string;
  required: boolean;
  autoComplete?: boolean;
  maxLength?: number;
  type: "email" | "text" | "tel" | "number" | "textarea";
  value?: string | number;
  min?: number;
  max?: number;
  variant?: "primary";
  elemRef?: RefObject<HTMLInputElement | HTMLTextAreaElement>;
}

const defaultProps = {
  className: "",
  onBlur: (value: string | number) => {},
  onFocus: (value: string | number) => {},
  onChange: (value: string | number) => {},
  required: false,
  autoComplete: true,
  type: "text"
};

class TextField extends Component<Props> {
  static defaultProps = defaultProps;

  render() {
    const {
      id,
      className,
      ariaLabel,
      label,
      name,
      onBlur,
      onFocus,
      onChange,
      pattern,
      placeholder,
      type,
      required,
      autoComplete,
      value,
      maxLength,
      variant,
      min,
      max,
      elemRef
    } = this.props;

    const classes = cx("TextField", className);

    const _id = id || name;

    return (
      <div
        className={cx(classes, `relative`, {
          [`TextField--style-${variant}`]: !!variant
        })}
      >
        {label ? <label htmlFor={_id}>{label}</label> : null}
        {type === "textarea" ? (
          <textarea
            aria-label={ariaLabel}
            id={_id}
            name={name}
            onBlur={e => onBlur(e.target.value)}
            onFocus={e => onFocus(e.target.value)}
            onChange={e => onChange(e.target.value)}
            placeholder={placeholder}
            required={required}
            value={value}
            ref={elemRef as RefObject<HTMLTextAreaElement>}
          />
        ) : (
          <div className="w100 relative flex justify-end items-center">
            <input
              aria-label={ariaLabel}
              id={_id}
              name={name}
              onBlur={e => onBlur(e.target.value)}
              onFocus={e => onFocus(e.target.value)}
              onChange={e => onChange(e.target.value)}
              pattern={pattern}
              placeholder={placeholder}
              type={type}
              min={min}
              max={max}
              required={required}
              maxLength={maxLength}
              value={value}
              autoComplete={autoComplete ? "on" : "off"}
              ref={elemRef as RefObject<HTMLInputElement>}
            />
          </div>
        )}
      </div>
    );
  }
}

export default TextField;
